"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3216,3606],{

/***/ 63606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_CheckOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/CheckOutlined.js
// This icon file is generated automatically.
var CheckOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };
/* harmony default export */ var asn_CheckOutlined = (CheckOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(42135);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/CheckOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CheckOutlined_CheckOutlined = function CheckOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_CheckOutlined
  }));
};
if (false) {}
/* harmony default export */ var icons_CheckOutlined = (/*#__PURE__*/react.forwardRef(CheckOutlined_CheckOutlined));

/***/ }),

/***/ 97286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getDetailReview; }
/* harmony export */ });
/* harmony import */ var _api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65255);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _constants_request_method__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17028);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26509);




const getDetailReview = async (reviewId, header)=>{
    const path = (0,url_join__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("v1/comments/".concat(reviewId));
    const response = await (0,_api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__/* .createFetcher */ .gt)(()=>({
            apiUrl: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG
        }))(_constants_request_method__WEBPACK_IMPORTED_MODULE_2__/* ["default"].GET */ .Z.GET, path, null, header);
    return response;
};


/***/ }),

/***/ 50859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getListSearchHistory; }
/* harmony export */ });
/* harmony import */ var _api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65255);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _constants_request_method__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17028);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26509);




const getListSearchHistory = async (header)=>{
    const path = (0,url_join__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("v1/projects/search-history");
    const response = await (0,_api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__/* .createFetcher */ .gt)(()=>({
            apiUrl: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG
        }))(_constants_request_method__WEBPACK_IMPORTED_MODULE_2__/* ["default"].GET */ .Z.GET, path, null, header);
    return response;
};


/***/ }),

/***/ 36361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ saveSearchHistory; }
/* harmony export */ });
/* harmony import */ var _api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65255);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _constants_request_method__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17028);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26509);




const saveSearchHistory = async (params, headers)=>{
    const path = (0,url_join__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("v1/projects/savehistory");
    const response = await (0,_api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__/* .createFetcher */ .gt)(()=>({
            apiUrl: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG
        }))(_constants_request_method__WEBPACK_IMPORTED_MODULE_2__/* ["default"].POST */ .Z.POST, path, params, headers);
    return response;
};


/***/ }),

/***/ 15085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40364);
/* harmony import */ var _components_MeeyImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3524);
/* harmony import */ var _components_PopupAvatarUser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84536);
/* harmony import */ var _components_PopupNotification__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8440);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7181);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33172);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Home_HeaderHome_SearchProject__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82620);









const HeaderDetail = ()=>{
    const { user , login  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .a)();
    // const [mounted, setMounted] = useState(false);
    // useEffect(() => {
    //   setMounted(true);
    // }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white flex items-center justify-between h-14 w-full pl-10 pr-[60px] sticky top-0 z-30 shadow-light-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                href: "/",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MeeyImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    src: _constants_environment__WEBPACK_IMPORTED_MODULE_5__/* .STATIC_DOMAIN */ .xm + "/logo_blue.svg",
                    alt: "home",
                    resizeOnFly: false,
                    resizeOptions: {
                        width: 131,
                        height: 42
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center bg-grey-100 w-[26.5rem] h-10 rounded-md py-2 pl-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "mrv mrv-search text-fs-20 text-grey-500"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Home_HeaderHome_SearchProject__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        showSuffixIcon: false,
                        className: "w-[calc(100%-32px)]",
                        allowClear: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center gap-5 w-[13rem] justify-end",
                children: [
                    !user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        color: "white",
                        onClick: login,
                        className: "meey-button meey-button-grey meey-button-outline py-2.5 px-4 h-9 flex items-center gap-1",
                        btnType: "outline",
                        prefixIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "mrv mrv-account_circle text-fs-18",
                            children: " "
                        }),
                        children: "Đăng nhập"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopupNotification__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopupAvatarUser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderDetail);


/***/ }),

/***/ 3009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Desktop_ReviewDetail; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/endpoint/reviews/get-detail-reviews.ts
var get_detail_reviews = __webpack_require__(97286);
// EXTERNAL MODULE: ./src/context/project.context.tsx
var project_context = __webpack_require__(12482);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 2 modules
var useAuth = __webpack_require__(33172);
// EXTERNAL MODULE: ./src/modules/common/ReviewDetail/index.tsx
var ReviewDetail = __webpack_require__(48531);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/modules/Desktop/ProjectDetail/HeaderDetail.tsx
var HeaderDetail = __webpack_require__(15085);
// EXTERNAL MODULE: ./src/components/MeeyImage.tsx
var MeeyImage = __webpack_require__(3524);
// EXTERNAL MODULE: ./src/components/PopOver/index.tsx + 2 modules
var PopOver = __webpack_require__(20951);
// EXTERNAL MODULE: ./src/constants/environment.ts
var environment = __webpack_require__(7181);
// EXTERNAL MODULE: ./src/constants/project-constant.ts
var project_constant = __webpack_require__(18825);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/modules/Desktop/ReviewDetail/HeaderDetailReview.tsx






const HeaderDetailReview = (param)=>{
    let { project  } = param;
    var _project_logo, _project_logo1, _project_title, _project_voteScore;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full h-fit bg-white shadow-light-1 sticky top-[3.5rem] z-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between gap-6 py-2 layout",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                            src: (project === null || project === void 0 ? void 0 : project.logo) ? project === null || project === void 0 ? void 0 : (_project_logo = project.logo) === null || _project_logo === void 0 ? void 0 : _project_logo.uri : "".concat(environment/* STATIC_DOMAIN */.xm, "/").concat(project_constant/* DEFAULT_LOGO_PROJECT */.J3),
                            alt: project === null || project === void 0 ? void 0 : project.title,
                            resizeOnFly: !!(project === null || project === void 0 ? void 0 : (_project_logo1 = project.logo) === null || _project_logo1 === void 0 ? void 0 : _project_logo1.uri),
                            resizeOptions: {
                                width: 0,
                                height: 108
                            },
                            className: "rounded-full h-9 w-9 border-2 border-solid border-grey-50 object-contain"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver/* default */.Z, {
                            trigger: "hover",
                            dropdownClassName: "mt-2 !p-0 rounded !bg-transparent",
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-1 px-2 bg-black-800 text-fs-14 text-white max-w-[30rem] break-word",
                                children: project === null || project === void 0 ? void 0 : project.title
                            }),
                            position: "bottom-left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/project/".concat(project.slug, "-").concat(project.shortId ? project.shortId : project._id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-fs-16 font-semibold text-grey-700",
                                    children: (project === null || project === void 0 ? void 0 : (_project_title = project.title) === null || _project_title === void 0 ? void 0 : _project_title.length) > 80 ? (project === null || project === void 0 ? void 0 : project.title.substring(0, 80)) + "..." : project === null || project === void 0 ? void 0 : project.title
                                })
                            })
                        })
                    ]
                }),
                (project === null || project === void 0 ? void 0 : project.totalHotReview) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        (project === null || project === void 0 ? void 0 : project.voteScore) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-fs-20 font-semibold text-grey-700",
                                    children: Number.isInteger(project === null || project === void 0 ? void 0 : project.voteScore) ? project === null || project === void 0 ? void 0 : project.voteScore : project === null || project === void 0 ? void 0 : (_project_voteScore = project.voteScore) === null || _project_voteScore === void 0 ? void 0 : _project_voteScore.toFixed(1)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-star text-[#FFC633] text-fs-20"
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-fs-16 text-grey-700",
                            children: [
                                "(",
                                project === null || project === void 0 ? void 0 : project.totalHotReview,
                                " reviews)"
                            ]
                        })
                    ]
                }) : null
            ]
        })
    });
};
/* harmony default export */ var ReviewDetail_HeaderDetailReview = (HeaderDetailReview);

// EXTERNAL MODULE: ./src/api/endpoint/reviews/get-reviews-reactions.ts
var get_reviews_reactions = __webpack_require__(85080);
;// CONCATENATED MODULE: ./src/modules/Desktop/ReviewDetail/index.tsx










const ReviewDetail_ReviewDetail = ()=>{
    const { query: { id  }  } = (0,router.useRouter)();
    const { userDataHeader  } = (0,useAuth/* useAuth */.a)();
    const { reviewDetail , setReviewDetail , project , projectListVote , setProjectListVote , listReviewsIds , listReviewReactions , setListReviewReactions  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const handleGetListReviewsReactions = async ()=>{
        const res = await (0,get_reviews_reactions/* getReviewsReactions */.f)(listReviewsIds, userDataHeader);
        if (res) {
            setListReviewReactions([
                ...listReviewReactions,
                ...res
            ]);
        }
    };
    (0,react.useEffect)(()=>{
        if (listReviewsIds === null || listReviewsIds === void 0 ? void 0 : listReviewsIds.length) {
            handleGetListReviewsReactions();
        }
    }, [
        listReviewsIds
    ]);
    const getDetail = async ()=>{
        const res = await (0,get_detail_reviews/* getDetailReview */.v)(id, userDataHeader);
        if (res) {
            setReviewDetail(res);
            setProjectListVote({
                ...projectListVote,
                results: res
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (userDataHeader) {
            getDetail();
        }
    }, [
        userDataHeader
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-grey-100 min-h-[calc(100vh-77px)]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDetail/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewDetail_HeaderDetailReview, {
                project: project
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "layout py-6",
                children: reviewDetail ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewDetail/* default */.Z, {
                    reviewDetail: reviewDetail
                }) : null
            })
        ]
    });
};
/* harmony default export */ var Desktop_ReviewDetail = (ReviewDetail_ReviewDetail);


/***/ }),

/***/ 48531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_AvatarWithName__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7869);
/* harmony import */ var _utils_datetime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61297);
/* harmony import */ var _constants_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24435);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _modules_common_ProjectDetail_ReviewItem_ListReplyReview_FormReplyReview__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8971);
/* harmony import */ var _modules_common_ProjectDetail_ReviewItem_ReviewDetailRate__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38762);
/* harmony import */ var _modules_common_ProjectDetail_ReviewItem_ReviewDetailTextContent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27083);
/* harmony import */ var _constants_enum_comment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44352);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(86010);
/* harmony import */ var _components_Share__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70731);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7181);
/* harmony import */ var _modules_Desktop_ProjectDetail_RightContent_ModalViewDetailFile__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25256);
/* harmony import */ var _modules_Mobile_ProjectDetailMobile_RightContent_ModalViewDetailFile__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19826);
/* harmony import */ var _context_project_context__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12482);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(26509);
/* harmony import */ var _context_device_context__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(99757);
/* harmony import */ var _modules_common_ProjectDetail_ReviewItem_BoxReply__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(18858);
/* harmony import */ var _components_PopOver__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(20951);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(33172);
/* harmony import */ var _ProjectDetail_ReviewItem_ReportModal__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(54973);
























const ListReplyReview = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(__webpack_require__.e(/* import() */ 739).then(__webpack_require__.bind(__webpack_require__, 40739)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(40739)
            ]
    },
    ssr: false
});
const ReviewDetailFileList = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(__webpack_require__.e(/* import() */ 936).then(__webpack_require__.bind(__webpack_require__, 10936)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10936)
            ]
    },
    ssr: false
});
const ReviewDetailAction = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(__webpack_require__.e(/* import() */ 9082).then(__webpack_require__.bind(__webpack_require__, 59082)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(59082)
            ]
    },
    ssr: false
});
let timeOutBachground = null;
const ReviewInfo = (param)=>{
    let { reviewDetail  } = param;
    const { selectedViewFiles , currentShowFormReply , setCurrentShowFormReport , currentRefItem  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_project_context__WEBPACK_IMPORTED_MODULE_14__/* .ProjectContext */ .x);
    const { user , login  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_19__/* .useAuth */ .a)();
    const [mounted, setMounted] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query: { id  } , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_15__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setMounted(true);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (mounted) {
            const reviewElement = document.getElementById("".concat(id));
            if (reviewElement) {
                reviewElement.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest"
                });
                reviewElement.style.background = "#EBF3FC";
                if (timeOutBachground) clearTimeout(timeOutBachground);
                timeOutBachground = setTimeout(()=>{
                    reviewElement.style.background = "unset";
                }, 2000);
            }
        }
    }, [
        mounted
    ]);
    const { isMobile  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_device_context__WEBPACK_IMPORTED_MODULE_16__/* .DeviceContext */ .T);
    return reviewDetail.map((data, index)=>{
        var _data_createdBy, _data_createdBy1;
        var _data_nickName;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProjectDetail_ReviewItem_ReportModal__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.04)"
                    },
                    ref: (ele)=>{
                        currentRefItem.current[index] = ele;
                    },
                    className: "gap-x-3 p-4 bg-white md:rounded-xl w-full overflow-auto border-b border-b-gray-200",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full first-letter:gap-x-3 overflow-auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-start gap-x-3 duration-300",
                                id: data._id,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AvatarWithName__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        imageClass: "md:!w-14 md:!h-14 !w-8 !h-8",
                                        imageProps: {
                                            resizeOnFly: false
                                        },
                                        className: "flex-[0_0_auto]",
                                        avatarOnly: true,
                                        alt: (_data_nickName = data === null || data === void 0 ? void 0 : data.nickName) !== null && _data_nickName !== void 0 ? _data_nickName : "Ẩn danh",
                                        name: data === null || data === void 0 ? void 0 : data.nickName,
                                        src: (data === null || data === void 0 ? void 0 : (_data_createdBy = data.createdBy) === null || _data_createdBy === void 0 ? void 0 : _data_createdBy.avatar) ? data === null || data === void 0 ? void 0 : (_data_createdBy1 = data.createdBy) === null || _data_createdBy1 === void 0 ? void 0 : _data_createdBy1.avatar : (data === null || data === void 0 ? void 0 : data.nickName) ? null : _constants_image__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_IMAGE_CARD */ .mq
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex-[1_1_auto] overflow-auto",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex justify-between w-full",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "text-grey-700 font-semibold md:flex items-center flex-1 justify-start table-cell align-middle",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: "md:line-clamp-1 break-word align-middle",
                                                                children: [
                                                                    data.nickName ? data.nickName : "Ẩn danh",
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "ml-1.5 text-grey-600 text-fs-14 font-normal whitespace-nowrap align-middle",
                                                                children: data.type === _constants_enum_comment__WEBPACK_IMPORTED_MODULE_9__/* .CommentTypeEnum.REVIEW */ .I.REVIEW ? "đ\xe3 viết review" : "đ\xe3 đặt c\xe2u hỏi"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)("mrv  text-fs-24 text-grey-400  ml-1.5 cursor-pointe flex-0 align-middle", data.type === _constants_enum_comment__WEBPACK_IMPORTED_MODULE_9__/* .CommentTypeEnum.REVIEW */ .I.REVIEW ? "mrv-review" : "mrv-contact_support")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex-0 flex gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Share__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                shareUrl: (0,url_join__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(_constants_environment__WEBPACK_IMPORTED_MODULE_11__/* .APP_BASE_URL */ .E5, asPath),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "mrv mrv-share text-fs-24 ml-1.5 cursor-pointer"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopOver__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                                dropdownClassName: "px-2 py-2.5 rounded-lg shadow-light-2",
                                                                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "flex items-center w-56 cursor-pointer",
                                                                        onClick: ()=>user ? setCurrentShowFormReport(data._id) : login(),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                className: "mrv mrv-report text-fs-20 mr-2 cursor-pointer"
                                                                            }),
                                                                            "B\xe1o c\xe1o b\xe0i viết"
                                                                        ]
                                                                    })
                                                                }),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "mrv mrv-more_vert text-fs-24 ml-1.5 cursor-pointer"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-grey-500 text-fs-14",
                                                children: (0,_utils_datetime__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeTime */ .ni)(new Date(data === null || data === void 0 ? void 0 : data.publishedAt))
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-full overflow-auto",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_ProjectDetail_ReviewItem_ReviewDetailRate__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                        data: data
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_ProjectDetail_ReviewItem_ReviewDetailTextContent__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                        data: data
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewDetailFileList, {
                                                        data: data
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewDetailAction, {
                                                        data: data
                                                    }),
                                                    currentShowFormReply ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_ProjectDetail_ReviewItem_BoxReply__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                        data: data
                                                    }),
                                                    currentShowFormReply == data._id ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_ProjectDetail_ReviewItem_ListReplyReview_FormReplyReview__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        data: data,
                                                        reviewItem: data,
                                                        reviewIndex: index
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "ml-14 reply-review-list",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListReplyReview, {
                                    reviewIndex: index,
                                    data: data
                                })
                            })
                        ]
                    })
                }),
                (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile) ? isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_Mobile_ProjectDetailMobile_RightContent_ModalViewDetailFile__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_Desktop_ProjectDetail_RightContent_ModalViewDetailFile__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {}) : null
            ]
        }, data._id);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReviewInfo);


/***/ })

}]);